module.exports = __webpack_public_path__ + "static/media/hari-crop.c4ab1a05.png";